<template>
  <div class="rate">
    <el-button class="btn-right" type="primary" @click="onBatch" v-if="isBatch">
      批量设置结佣比例
    </el-button>
    <div class="table-link" @click="onOpenDialog" v-else>设置佣金比例</div>
    <el-dialog v-if="dialogVisible" title="设置佣金比例" :visible.sync="dialogVisible" width="540px" modal-append-to-body
      append-to-body>

      <div class="table-num" v-if="isBatch">已选中{{ ids.length }}个</div>
      <el-form label-width="100px" :model="form" :rules="rules" ref="form">
        <el-form-item label="佣金比例" prop="value">
          <el-input v-model="form.value" placeholder="请输入">
            <template slot="append">%</template></el-input>
          <span class="color-gray"> 佣金=达人营业额 x 佣金比例</span>
        </el-form-item>
      </el-form>
      <div class="rate-tip">
        <div class="color-pink">
          <div><i class="el-icon-info"></i>温馨提示：</div>
          <div>
            1、此比例是您给分销达人的分佣比例，非平台给您的分佣比例。
          </div>
          <div>
            2、佣金比例设置成功后，对新订单生效。
          </div>
        </div>
      </div>
      <span slot="footer">
        <el-button @click="onCancel">取 消</el-button>
        <el-button type="warning" @click="onSure" :loading="saveLoading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import douYin from "@/javaApi/douyin";
import { matchFractionalPart1 } from "@/utils/regExp";
const DouYinModel = new douYin();
export default {
  props: {
    row: {
      // 行数据
      type: Object,
      default: () => { },
    },
    isBatch: {
      // 是否是批量操作
      type: Boolean,
      default: false,
    },
    ids: {
      // ids的集合
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      form: {
        value: "", // 佣金比例
      },
      saveLoading: false, // 保存按钮
      dialogVisible: false, // 显示弹框
      rules: {
        value: [
          {
            required: true,
            message: "请输入佣金比例 ",
            trigger: ["blur", "change"],
          },
          {
            required: true,
            pattern: matchFractionalPart1,
            message: "请输入数字，最多保留一位小数 ",
            trigger: ["blur", "change"],
          },
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value > 8) {
                callback(new Error("请输入小于8的佣金比例"));
              } else {
                callback();
              }
            },
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  methods: {
    // 打开弹框
    onOpenDialog() {
      this.form.value = this.row.commissionRate;
      this.dialogVisible = true;
    },
    // 批量操作
    onBatch() {
      if (this.ids && this.ids.length) {
        this.dialogVisible = true;
      } else {
        this.$message.error("请先选择达人");
      }
    },
    // 取消
    onCancel() {
      this.$refs.form.resetFields();
      this.dialogVisible = false;
    },
    // 确定
    onSure() {
      if (this.ids && this.ids.length) {
        this.saveLoading = true;
        this.$refs.form.validate(async (valid) => {
          if (valid) {
            const data = await DouYinModel.setMasterCommissionRate({
              ...this.form,
              ids: this.ids.join(","),
            }).finally(() => {
              this.saveLoading = false;
            });
            if (data.data.code === 200) {
              this.onCancel();
              this.$emit("refresh");
              this.$message.success(data.data.message);
            } else {
              this.$message.error(data.data.message);
            }
          } else {
            this.saveLoading = false;
          }
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.el-form {
  margin-top: 20px;

  .el-input {
    width: 213px;
  }

}

.rate {
  &-tip {
    background: #FAFAFA;
    padding: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/douyin/distribution/SetCommissionRate.vue